var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"breadcrumb-nav",staticStyle:{"--bs-breadcrumb-divider":"'>'"},attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"breadcrumb-item"},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }